import React, { useContext } from "react";
import {
  CButton,
  CCardBody,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import styled from "styled-components";
import Draggable from "react-draggable";
import { AppContext } from "../context/AppContext";

const NewModalPage = ({
  show,
  title,
  message,
  left,
  right,
  onClose,
  danger,
  size,
}) => {
  const { isMobile } = useContext(AppContext);
  console.log(isMobile);
  return (
    <Draggable disabled={isMobile}>
      <CustomCModal show={show} onClose={onClose} centered color={danger}>
        {title && (
          <CModalHeader>
            <CModalTitle>{title}</CModalTitle>
          </CModalHeader>
        )}
        {message && (
          <CModalBody className="hello">
            <CCardBody>{message}</CCardBody>
          </CModalBody>
        )}
        <CustomCFooter>
          {left && (
            <CButton
              color="secondary"
              className="cancel_btn"
              onClick={() => onClose(left)}
            >
              {left}
            </CButton>
          )}
          {right && !danger && (
            <CButton
              color="info"
              className="confirm_btn"
              onClick={() => onClose(right)}
            >
              {right}
            </CButton>
          )}
          {danger && (
            <CButton color="danger" onClick={() => onClose(danger)}>
              {danger}
            </CButton>
          )}
        </CustomCFooter>
      </CustomCModal>
    </Draggable>
  );
};

export default NewModalPage;

const CustomCFooter = styled(CModalFooter)`
  border-top: none;
  justify-content: center;

  button {
    font-size: 1rem;
    width: 200px;
    height: 40px;
  }

  button:nth-child(1):nth-last-child(2),
  button:nth-child(1):nth-last-child(2) ~ button {
    width: 45%;
  }
`;

const CustomCModal = styled(CModal)`
  > div {
    max-width: 400px;
  }

  .modal-body {
    display: flex;
    align-items: center;
  }
`;
